import { css } from 'linaria';

export const sitemapTitle = css`
  && {
    @media (--only-largeDesktop) {
      margin-bottom: 42px;
    }

    @media (--to-largeDesktop) {
      margin-bottom: 48px;
    }
  }
`;

export const sitemapRootNodeContainer = css`
  width: 100%;
  margin-bottom: 64px;

  @media (--only-desktop) {
    margin-bottom: 48px;
  }
`;

export const sitemapRootNode = css`
  margin-bottom: 8px;
`;

export const sitemapRootNodeChildren = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 32px;
  row-gap: 24px;

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`;

export const sitemapDivider = css`
  && {
    margin-bottom: 48px;
  }
`;

export const sitemapSecondNode = css`
  margin-bottom: 12px;
`;

export const sitemapExpandLevel = css`
  display: flex;
  column-gap: 12px;
  padding: 8px 0;
  align-items: center;
`;

export const sitemapNestedLevel = css`
  margin-left: 32px;
`;

export const sitemapChevronIcon = css`
  cursor: pointer;
`;

export const sitemapOpenChevronIcon = css`
  transform: rotate(90deg);
`;

export const sitemapHideChildren = css`
  display: none;
`;

export const sitemapRow = css`
  padding: 8px 0;
`;